import {

  getConfoList,
  getConfoDetailList,
  getConfoExtenList
} from "@/api/conferencejs";


export default {
  state: {
    confno: '',
    conf_num: '',
    pin: '',
    confname: '',
    support_record: '',
    route_group_id: false,
    tmp: true,
    membernum: 0,
    isVideo: '0',
    rooms: [],
    participants: [],
    currRoom: '',
    tempRoom: '',
    kmsConnected: true,
  },
  mutations: {
    setRooms(state, rooms) {
      state.rooms = rooms
    },
    setKmsConnected(state, connected) {
      state.kmsConnected = connected
    },
    setTempRoom(state,tempRoom){
      state.tempRoom  = tempRoom
    },
    addRoom(state, room) {
      let add = true
      if (!room.name || !room.number) {
        return
      }

      for (let i = 0; i < state.rooms.length; i++) {
        let sRoom = state.rooms[i]
        if (sRoom.name == room.name) {
          /*if (sRoom.isVideo) {
            if (sRoom.number == room.number) {
              add = false
              break
            }

          } else {
            add = false
            break
          }*/
          add = false
          break
        }
      }
      if (add) {
        state.rooms.push(room)
      }
      //console.log(state.rooms)
    },
    removeRoom(state, room) {
      if (state.rooms.length <= 0) {
        return console.log('rooms is empty!')
      }
      let index = -1
      for (let i = 0; i < state.rooms.length; i++) {
        if (state.rooms[i].name === room.name) {
          index = i
          break
        }
      }
      if (index > -1) {
        let rr = state.rooms.splice(index, 1)
        console.log('remove room:', rr.name)
      } else {
        console.log('room :'+room.name+' not existing!')
      }
    },
    setCurrRoom(state, roomName) {
      state.currRoom = roomName
    },
    setConfNo(state,confno){
      state.confno = confno
    },
    setConfName(state, conf_name) {
      state.confname = conf_name
    },
    setConfNum(state, conf_num) {
      state.conf_num = conf_num
    },
    setConfTmp(state, tmp) {
      state.tmp  = tmp
    },
    setConfRecord(state, tmp) {
      state.support_record  = tmp
    },
    setIsVideo(state, isVideo) {
      state.isVideo  = isVideo
    },
    setMemberNum(state, membernum) {
      state.membernum  = membernum
    }
    ,
    AddMemberNum(state, confo) {
      state.membernum  = state.membernum+1
      if(tstate.membernum<1)state.membernum=0
    }
    ,
    DelMemberNum(state, confo) {
      state.membernum  = state.membernum-1
      if(tstate.membernum<1)state.membernum=0
    }
  },
  actions:{
    getConfList({state, commit},{intercom}) {
      return new Promise((resolve, reject) => {
        try {
          getConfoList({intercom}).then(res=>{
            //console.log(res);
            if(res.data.statuscode == '000000'){
              let data = res.data;
              //console.log("data:",data);
              resolve(data);
            }else {
              resolve()
            }
          }).catch(err=>{
            reject(err)
          })
        }catch (error) {
          reject(error)
        }
      })
    },
    getRoom({state}, roomName) {
      let rooms = state.rooms
      if (rooms.length < 0) {
        return null
      }
      for (let i = 0; i < rooms.length; i++) {
        let room = rooms[i]
        if (room.name === roomName || room.no === roomName) {
          return room
        }
      }
    },
    getConfDetailList({state, commit},{intercom,confno}) {
      return new Promise((resolve, reject) => {
        try {
          getConfoDetailList({intercom,confno}).then(res=>{
            if(res.data.statuscode == '000000'){
              let data = res.data;
              //console.log("data:",data)
              resolve(data);
            }else {
              resolve()
            }
          }).catch(err=>{
            reject(err)
          })
        }catch (error) {
          reject(error)
        }
      })
    },
    getConfExtenList({state, commit},) {
      return new Promise((resolve, reject) => {
        try {
          let type='2';
          getConfoExtenList({type}).then(res=>{
            if(res.data.statuscode == '000000'){
              let data = res.data;

              resolve(data);
            }else {
              resolve()
            }
          }).catch(err=>{
            reject(err)
          })
        }catch (error) {
          reject(error)
        }
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/module/conferencejs.js